<!-- !TODO Create a custom directive or component to accept a url and return the correct href or routerLink attribute depending on path. -->
<section
  class="logos-section"
    [ngStyle]="{
        'background-color': get(logosRow, 'logos.logos[0].background_color', ''),
        'background-repeat': 'no-repeat'
    }"
  >
  @for (row of get(logosRow, 'logos.logos', []); track row) {
    <div>
      <div class="d-flex flex-column container">
        @if (get(row, 'partnership', false)) {
          <div class="partners-top-title fx-row col-xs-12">
            <img src="https://images.exxactcorp.com/img/exx/misc/x-emblem.svg" alt="logo" />
            <div class="d-flex flex-column justify-content-center pl-3">
              <h2 class="pb-1 mb-0">Partnerships</h2>
            </div>
          </div>
        }
        @if (!get(row, 'partnership', false) && get(row, 'logos_title', '')) {
          <div class="d-flex justify-content-center">
            @if (get(row, 'logos_title', '')) {
              <h2 class="col-md-7 text-center title">
                {{ get(row, 'logos_title', '') }}
              </h2>
            }
          </div>
        }
        <div class="logos-container" [class.justify-content-center]="get(row, 'justification', '') == 'center'">
          @for (logo of get(row, 'logos', []); track logo) {
            <div class="logo-item">
              @if (get(logo, 'logo_link', '').length > 0) {
                @if (logo.logo_link.startsWith('http')) {
                  <a [href]="logo.logo_link" class="logo-link">
                    @if (get(logo, 'image.href', '')) {
                      <img [src]="getWebpImg(logo.image.href)" [alt]="logo.image.title" />
                    }
                  </a>
                }
                @if (logo.logo_link.startsWith('/')) {
                  <a [routerLink]="logo.logo_link" class="logo-link">
                    @if (get(logo, 'image.href', '')) {
                      <img [src]="getWebpImg(logo.image.href)" [alt]="logo.image.title" />
                    }
                  </a>
                }
              }
              @if (get(logo, 'image.href', '') && get(logo, 'logo_link', '') == '') {
                <img
                  [src]="getWebpImg(logo.image.href)"
                  [alt]="logo.image.title"
                  />
              }
            </div>
          }
        </div>
      </div>
    </div>
  }
</section>
@if (get(logosRow, 'logos.split_line', '')) {
  <hr class="m-0 mb-3" />
}
